import React from 'react';
import {Grid} from '@mui/material';
import SessionTileStat from './SessionTileStat';

const SessionGridItem: React.FC<{
  label: string;
  value: string | number | null;
  comparison?: 'up' | 'down';
  unit?: string;
}> = ({label, value, comparison, unit}) => (
  <Grid item xs={4} lg={2}>
    <SessionTileStat
      label={label}
      value={value ?? '--'}
      comparison={comparison}
      unit={unit}
    />
  </Grid>
);

export default SessionGridItem;
